import { accessRole } from "../../../../helpers/access_role"

import React, { Fragment, useState, useRef } from "react"
import classnames from "classnames"
import { Link } from "react-router-dom"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane
} from "reactstrap"

import TableActiveComponent from './Components/TablePrimaryComponent'
import PegawaiSideBar from "../../GlobalComponents/PegawaiSidebar"


const IndexView = (props) => {

    const [activeTab, setactiveTab] = useState("1")    
    const activeRef = useRef();
    const inactiveRef = useRef();

    const reloadActiveRef = () => activeRef.current.setTokenAPI()
    const reloadInactiveRef = () => activeRef.current.setTokenAPI()

    function toggle(tab) {
        if (activeTab !== tab) {
            setactiveTab(tab)
        }
    }

    return (
        <Fragment>
            <Container fluid>
                <Row>
                    <Col xs="12">

                        <PegawaiSideBar active="riwayatpenugasan"/>

                        <Card className="pegawai-rightbar">
                            <CardBody>
                                <div className="float-end">
                                {
                                    (accessRole('create')) ?
                                        <Link to="?riwayatpenugasan&create">
                                            <Button color="primary">Tambah Data Riwayat Penugasan</Button>
                                        </Link>
                                    : null
                                }
                                </div>
                                <CardTitle>Daftar Riwayat Penugasan</CardTitle>
                                <CardSubtitle className="mb-3">
                                    Kelola Daftar Riwayat Penugasan
                                </CardSubtitle>
                                <hr />
                                <TableActiveComponent ref={activeRef} handleInactiveSuccess={reloadInactiveRef}/>
                            </CardBody>
                        </Card>
                        
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default IndexView